{
    "FormEngineSessionLogWfl": {
        "title": "Session Log",
        "description": "Take a snapshot of the current state of the form",
        "retention": "Retention (days)"
    }
}